const REQUIRED_PARAM = ['AWSAccessKeyId', 'Expires', 'Signature'];

export default function pickupPresignParameter(parameter) {
  const clone = { ...parameter };
  Object.keys(clone)
    .filter((key) => !REQUIRED_PARAM.includes(key))
    .forEach((key) => delete clone[key]);
  return clone;
}
